import ListingPrioritiesManagement from './ListingPrioritiesManagement';

export default ListingPrioritiesManagement;
